module.exports = __webpack_public_path__ + "img/04.a9db3540.jpg";